import { useTranslate } from '@refinedev/core';
import { Card, Descriptions, Typography } from 'antd';
import type { DescriptionsProps } from 'antd';
import type { MonetizationCustomerDetailOut } from '@/api/generated/schemas';
import { ShowLink } from '@/components/common/ShowLink';
import { orDash, useVerticalDescProps } from '@/components/common/show/shared';
import { formatDateTime } from '@/utils/format';

interface CustomerGeneralTabProps {
  record: MonetizationCustomerDetailOut;
}

export const CustomerGeneralTab = ({ record }: CustomerGeneralTabProps) => {
  const t = useTranslate();
  const verticalDescProps = useVerticalDescProps();
  const f = (key: string) => t(`monetization.customers.fields.${key}`);

  const items: DescriptionsProps['items'] = [
    { key: 'id', label: t('base.fields.id'), children: orDash(record.id) },
    {
      key: 'account_id',
      label: f('account_id'),
      children: orDash(record.account_id),
    },
    {
      key: 'user_id',
      label: f('user_id'),
      children: orDash(
        record.user_id != null && (
          <ShowLink resource="iam.users" id={record.user_id} />
        )
      ),
    },
    {
      key: 'revenuecat_customer_id',
      label: f('revenuecat_customer_id'),
      children: orDash(
        <Typography.Text code>{record.revenuecat_customer_id}</Typography.Text>
      ),
    },
    {
      key: 'owner_email',
      label: f('owner_email'),
      children: orDash(record.owner_email),
    },
    {
      key: 'owner_username',
      label: f('owner_username'),
      children: orDash(record.owner_username),
    },
    {
      key: 'created_at',
      label: t('base.fields.created_at'),
      children: orDash(formatDateTime(record.created_at)),
    },
    {
      key: 'updated_at',
      label: t('base.fields.updated_at'),
      children: orDash(formatDateTime(record.updated_at)),
    },
  ];

  return (
    <Card title={t('base.sections.basic_info')}>
      <Descriptions
        {...verticalDescProps}
        column={{ xs: 1, sm: 2, md: 3 }}
        items={items}
      />
    </Card>
  );
};
